<template>
	<div class="certificate-generate">
		<b-card-group deck>
			<b-card header-tag="header" footer-tag="footer">
				<div slot="header" class="top-card">
					<span>
						<h5>{{$t('certificate.generate')}}</h5>
					</span>
					<b-button variant="outline" @click.prevent="closeSidebar">
						<i class="fa fa-close"></i>
					</b-button>
				</div>
				<div >
					<b-alert class="errorField" variant="danger" :show="errorAlert">{{$t('certificate.errorMessage')}}</b-alert>
				</div>
				<b-form @submit.enter.prevent="onGenerate">
					<div class="top-form">
						<b-container fluid>
							<b-row class="my-1">
								<b-col sm="3">
									<label for="input-small">
										<span class="redStar">
											*
										</span>
										<span>
											{{$t('certificate.quantity')}}
										</span>
									</label>
									<b-input-group
										size="sm"
										class="mb-3"
									>
										<b-form-input
											:placeholder="$t('certificate.quantity')"
											v-model="items.quantity"
											type="number"
											min="0"
										>
										</b-form-input>
									</b-input-group>
								</b-col>
								<b-col sm="3">
									<label for="input-small">
										<span class="redStar">
											*
										</span>
										<span>
											{{$t('certificate.expirationDate')}}
										</span>
									</label>
									<b-input-group size="sm" class="mb-3">
										<masked-input
											v-model="items.expirationDate"
											mask="11-11-1111"
											class="ml-1 form-control form-control-sm"
											:placeholder="$t('certificate.expirationDate')"
										/>
										<b-input-group-addon>
											<b-button size="sm" disabled>
												<i class="fa fa-calendar"></i>
											</b-button>
										</b-input-group-addon>
									</b-input-group>
								</b-col>
								<b-col sm="3">
									<div class="certificate-money" v-if="getType">
										<label for="input-small">
										<span class="redStar">
											*
										</span>
											<span>
											{{$t('certificate.mount')}}
										</span>
										</label>
										<b-input-group
											size="sm"
											class="mb-3"
										>
											<b-form-input
												:placeholder="$t('certificate.mount')"
												v-model="items.mount"
												type="number"
												min="0"
											>
											</b-form-input>
										</b-input-group>
									</div>
									<div class="certificate-percent" v-if="!getType">
										<label for="input-small">
										<span class="redStar">
											*
										</span>
											<span>
											{{$t('certificate.percent')}}
										</span>
										</label>
										<b-input-group
											size="sm"
											class="mb-3"
										>
											<b-form-input
												:placeholder="$t('certificate.percent')"
												v-model="items.mount"
												type="number"
												min="0"
											>
											</b-form-input>
										</b-input-group>
									</div>
								</b-col>
								<b-col sm="3">
									<b-form-group
										style="font-size: 12px;padding-top: 3px"
										id="exampleInputGroup3"
										label-for="refCode"
										class="required"
									>
										<label class="lebeltop">{{$t('certificate.typeList')}}</label>
										<b-form-select v-model="type"
													   :plain="false"
													   size="sm"
													   :required="true"
													   :text-field="'name'"
													   :value-field="'id'"
													   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">

											<template slot="first">
												<!--<option :value="null" disabled>-->
													<!--&#45;&#45;{{$t('certificate.type')}}&#45;&#45;-->
												<!--</option>-->
												<option value="MONEY">{{$t('money.money')}}</option>
												<option value="PERCENT">{{$t('money.percent')}}</option>
											</template>
										</b-form-select>
									</b-form-group>
								</b-col>
								<b-col sm="3">
									<label for="input-small">
										<span class="redStar">*</span>
										{{$t('pricing.department')}}
										<!--<span class="isErrorDepartment" v-if="isInvalid">-->
											<!--{{$t('pricing.errorDepartment')}}-->
										<!--</span>-->
									</label>
									<multiselect
										v-model="selectedDepartment"
										:options="getDepartmentsLocal()"
										:multiple="true"
										:group-select="true"
										track-by="id"
										label="name"
										:show-labels="false"
										:allow-empty="true"
										class="multiselect-pricing"
									>
										<span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
									</multiselect>
								</b-col>
								<b-col sm="3">
									<label for="input-small">
										<span class="redStar">
											*
										</span>
										<span>
											{{$t('certificate.packageName')}}
										</span>
									</label>
									<b-input-group
										size="sm"
										class="mb-3"
									>
										<b-form-input
											:placeholder="$t('certificate.packageName')"
											v-model="items.packageName"
											type="text"
										>
										</b-form-input>
									</b-input-group>
								</b-col>
								<b-col sm="6" class="generateBtnFrame">
									<b-button variant="outline-primary" type="submit" class="generateBtn">
										<i class="fa fa-bookmark"></i>
										<span>
											{{$t('certificate.generateButton')}}
										</span>
									</b-button>
								</b-col>
							</b-row>
						</b-container>
					</div>
				</b-form>
			</b-card>
		</b-card-group>
	</div>
</template>

<script>
	import {mapActions, mapGetters} from "vuex";
	import MaskedInput from 'vue-masked-input'
	import Multiselect from 'vue-multiselect'
	export default{
		components:{
			MaskedInput,
			Multiselect
		},
		data(){
			return{
				isMoney:false,
				items:{
					mount:'',
					expirationDate:'',
					quantity:'',
					packageName:''
				},
				errorAlert:false,
				currentPage: 1,
				perPage: 20,
				selectedDepartment: [],
				type:'PERCENT',
			}
		},
		methods:{
			...mapActions('prices', [
				'getDepartmentList'
			]),
			...mapActions('certificates', [
				'generateCertificate','getCertificateList'
			]),
			async onGenerate(){
				if (this.items.mount !== '' && this.items.expirationDate !== '' && this.items.quantity !== '' && this.items.packageName !== '' && this.items.type !== '' && this.selectedDepartment.length != 0){

					const departments = this.selectedDepartment.map((department) => {
						return department.id
					});

					let data = {
						count:this.items.quantity,
						value:this.items.mount,
						expiredDate:this.items.expirationDate,
						type:this.type,
						departmentIds:departments,
						certificatePackageName:this.items.packageName
					}
					await this.generateCertificate(data)

					let getData = {
						page: this.currentPage,
						limit: this.perPage
					};
					await this.getCertificateList(getData);

					this.$emit('closeSidebar')
					this.items.mount = ''
					this.type = 'PERCENT'
					this.selectedDepartment = []
					this.items.expirationDate = ''
					this.items.quantity = ''
					this.packageName=''
					this.errorAlert = false
				}else{
					this.errorAlert = true
				}
			},
			closeSidebar(){
				this.items.mount = ''
				this.items.expirationDate = ''
				this.items.quantity = ''
				this.packageName=''
				this.errorAlert = false
				this.$emit('closeSidebar')
			},
			getDepartmentsLocal() {
				return this.getDepartments
			},
		},
		async mounted(){
			await this.getDepartmentList()

			// functions from methods
			this.getDepartmentsLocal()
		},
		computed:{
			getType(){
				if (this.type === "MONEY"){
					return true
				}else if(this.type === "PERCENT"){
					return false
				}
			},
			...mapGetters('certificates', [
				'getCertificates'
			]),
			...mapGetters('prices', [
				'getDepartments',
			]),
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	.redStar{
		color: red;
	}
	.top-card{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	input[type=number]::-webkit-inner-spin-button,
	input[type=number]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	.generateBtnFrame{
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.generateBtn span{
		margin-left: 5px;
	}
	.isErrorData{
		color: red;
	}
	.errorField{
		display: flex;
		justify-content: center;
		padding: 12px 0 12px 0;
		width: 100%;
	}
	.input-group .form-control {
		margin-left: 0 !important;
	}
</style>
